//Errores
$(document).on('click','.hide-error',function(){
    $(this).parent().hide();
});

